<template>
  <!--/*缅怀英烈，守护有我*/-->
  <div class="recollection">
    <div class="contentnr">
      <iframe width="100%" height="100%" id="show-iframe" :src=iframeling frameborder="0"></iframe>
      <div class="contentnr-text">向为中国人民解放事业和共和国建设事业英勇献身的烈士致敬</div>
      <div class="contentnr-btn">
        <div class="looking-forward">
          <span></span>
          <a href="http://yinglie.chinamartyrs.gov.cn/lieshijinianguan/" target="_blank">
            主题公祭
          </a>
        </div>
        <div class="memorial-service">
          <span></span>
          <a href="http://yinglie.chinamartyrs.gov.cn/LingYuanZhanShi/lingyuan/vrlist.html" target="_blank">线上瞻仰</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        iframeling: ""
      }
    },
    mounted() {
      this.$on('bridge', (val) => {
        this.iframeling = 'http://yinglie.chinamartyrs.gov.cn/xianhua/'
      });
    },
    components: {},
    methods: {},

  }
</script>
<style scoped>
 /* @media screen and (max-width:1366px) {
    .contentnr-text{
      font-size: 30px;
    }
  }*/

  .recollection {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .contentnr {
    position: relative;
    z-index: 0;
    width: 80%;
    height: 80%;
  }

  .contentnr-text {
    font-size: 25px;
    color: white;
    position: absolute;
    left: 20px;
    top: 20px;
    height: 150px;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: left;
    z-index: 1000000;
  }

  .contentnr-btn {
    width: 150px;
    position: absolute;
    right: 20px;
    top: 20px;
    height: 120px;
    text-align: right;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    z-index: 1000000;
  }

  /*  .contentnr-btn>div{
      width: 150px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: white;
      background-color: #40a9ff;
      font-size: 13px;
      margin-bottom: 20px;
      cursor: pointer;
    }*/
  .contentnr-btn > .looking-forward > a, .memorial-service > a {
    font-size: .114583rem;
    display: inline-block;
    color: #fff;
    line-height: .239583rem;
    font-weight: 700;
    margin-right: 8px;
  }

  .contentnr-btn > .looking-forward > span {
    display: inline-block;
    width: .166667rem;
    height: 80%;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAArCAYAAAAZvYo3AAAB5klEQVRYhe2XMWgUQRhGn8khgkjEIpgmhYWoabSxEQQrbQQVFEELLcTWzkIbG7FLIVioaGEZiKVVsAmYKIg2kkpBwUIQFG00F5+MN6eT9RJ39253Ee6DZWd3hv97uzPzz8wGlT60GzgCTJcN0S/AXeAwsANYLhUhAJS8JtXvdnSubJx+AO74R6/VjXUCTKltV+tSnQBz/q1P6ngdAGd6mHc1UzXAdvVjYvhKvZWBOFUlwIOM2Wl1Qv2avPugjlUBsE1dTowW1JFYdy0DdiFv3JECKWMKaMXyCnAR+BGfrwNLSdudeYMWAWgl5YfAy+T5W4Toql0FwPMk3b7tUf8+KS/mjlpwEE7HPn6jbs7U3Yt1S2qrqlmwSZ2PRs/UE+oh9X5891ndUyRmntVwAjgKHAT2xQHWWqf9O+AF8AR4FMulumBUvdkj5xfV47hyFu6CY30ap7pdJg9s/VffFND4Wk3zTMOQdBYGCFMYIJgfaBKgnaTcRgAq1RBgCDAEGAL8FwB7gRtNAowBl5sEqFTr7e3mgfMDMu+1jf+lAHAFOFnfN6/STNgVh/V+tCGAlTAGZhsyD5oNf2AL8BTYVbN5OMzuD3/gC3A83uvSb8/uNAw0Z2sECF6d43zmoHB1gIeRtRQ8On7KTy5Si5FuJd9VAAAAAElFTkSuQmCC);
    background-size: 100% 100%;
    vertical-align: bottom;
    margin: .015625rem .052083rem .036458rem -.052083rem;
  }

  .contentnr-btn > .looking-forward, .contentnr-btn > .memorial-service {
    border-radius: 5px;
    background-size: 100% 100%;
    width: 100%;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANkAAAAyCAYAAADRPX43AAAE1ElEQVR4nO2db47jNByGXzvuzGraGTp7B8QV9vMKOMCeBsH3ERfYy8AegCMs4gaA2GpnGE3/xEZukuK6tuO08UwR7yNFTuyfHSfxUzv5UnH/Hlh/wpebBX7cPOBr/YgbvQJMDcC02wiIth3hNSUC+6G80H4sPlRHesdD01TbOWWxaz4X3Mec2g+VpfJz6+lE3Zy2UnX8/b2YMR5GOzBEBcgLQF7hs5rhg5rju8ktflPrT/hq9Qd+Wf+F+WYB1H8DegmgBsyJguUMtF1qwmWpgSwzYrpj7Rz7cbE6Oe12eSYifeiaTU/ccxIafLkimQwZhpTnxHfPMadPcCQKiZfKH4qw57GSXQLVFDf1HO/0Gm8BvFGbBe6sYOvfgbWV7B7QT4DRp585NUuFpAvFhKSCI87eOczh4Pfb6pMstz5CYmXer3OeyZKSiTyZQmWpen2yuaL4ZSHpYtfinz+UHo2dySQgXwHVNWBW24bmcoI7ZZeIdgazgm3+BDYPjWTYtGfTp569IWd5FswzhzMAvEEfEsFdnvZJE4sPCXXQ356n47cRjBlpST6Evl949A1+EZbEj91tAVGiQopIfuBcOtKnUP9T6Ul07yKqkcwsm0NxsZ3VvlX2HcwuEe0MZgWrF+1ycWSOlsw5dmcuGREoJ++lOMcZzCdnVvKPsyTrKRsSrzP6FOp/Kh3t/j01qbgE6imgHzFT9iOHlcrOXtttOdrkVXRQaecH5Dn4LwhyDhwjzZB4nSHVMZKNJtsSEK5LK0BuvyLW7TvYJqMRQkiaTetT3Xyll1Zh48/3hJDjaafbzit58BZJCBkP87yvNYT8L6FkhBSGkhFSGEpGSGEoGSGFoWSEFIaSEVIYSkZIYSgZIYWhZIQUhpIRUhhKRkhhKBkhhaFkhBSGkhFSGEpGSGEoGSGFoWSEFIaSEVIYSkZIYSgZIYWhZIQUhpIRUhhKRkhhKBkhhaFkhBSGkhFSGEpGSGEoGSGFoWSEFIaSEVIYSkZIYSgZIYWRe/84TuUIGRfRSiYE/96fkNGQjU+dV1JUACpA2ALF+0zIyajWJ+tVBSh5AchLQL5qNvMEYDn+fRYZaSjGz+/2ZaI8lReL7csnw55zKexz1wXaHqvfrkvb/Qsr2RU+V1PcVNeAaeUSVrRNW2ukKzpaMrMvFrz4qCDmMC90vlS8L1nwXCZe5u9HMYNu5ThEOpU92IaOykS8aG/BbhP/3hIT2NymtHP7unp+XWSkJ9ENTNXIpWaA9amaAvIKD0rN8KGe491OsEtAPwFGn/7w/QEaSt3ylHhwZi/EJDB5UoXOl4rry9+VB4QL3Q8/fQli53Yf+UGMODw0kcF8II5XHpLHz4cjXazM7VKsrdD1xdKjEc0S0UpmBZt8Aaj5VriflJrjB73GWwBzK1g9BbQVrgZMAcn8411qwmWxmQTekjEW0ydNTp0hMbHY0D04J3L71sWZgFDokaWvPCfeXVj5EvltwBMUGdIdy/YjR9UsEe0MZgWbvMbC+qUmt/gI4I2c4K6a4hv9iGu9Akwd+Sk4thPOr/xefmA/Jmdq6RbKd8ukdzw0TbWdUxa75pfGlSbVN9Ejlj/Y/TRW3u138uQs70Jtper4+3sxYzyMdmDYjxzbbxxXuFcz/Kzm+H5yi1//AXazK8Tk2Bn/AAAAAElFTkSuQmCC);
  }

  .contentnr-btn > .memorial-service > span {
    display: inline-block;
    width: .166667rem;
    height: 80%;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAADdklEQVR4Xu2aT4hVZRiHf4+ILfxTuBpFWg2T0KYUaSOmtinSaCMy1EYiycUQjCEKok6QClNEMlCCSKBGSJsxEgrGwtlJMC5kCgZXEaOr0f4hSL7y1RDjOMyde+f3nrlD54VZ3Xue8/ue893vnO+dgxaoImKjpJ2SnpB0AbixEFGo+qSTA98rqfxNra8lDQDfVZmpMgGzDHz6eM9JOgmMViEiXUATA58+3k8kHQTuZYpIExARqyWdmGGqNzOeu5KOAKeaOaiZ72YKOC7pUDNhZvnuy8C3JtYjmEwB5ar1mELvAr4ysSoTcFbSHlPoPcDnJlZlAi5K2mUK3QMMmFiVCbgs6RVT6EPASROrMgHDkjabQn8AHDaxKhMwIuk5U+hTwLsmVmUCxiR1mkKfBd4ysSoTMC6pwxT6IrDbxKpMwB+SlptCXwZeNbHyBUTEEkl/GwMPA1uMvP9QKU+CEfGkpDvGwCPABiMvXcA6Sb8YA48BXUZeuoD1kn4yBh4H1hp56QI2SbpmDPw7sMrISxewXdKQMzCQsl6lQCPiNUmDTgGSVgB/mpnKEvCGpPPmsGuAW2ZmmoB3JH1qDtsFlMdra2XNgPck9VuTShuAssGyVpaAvtLMtCaVXgSumplpP4GPJPWaw+4AvjEz0wScnmc7fKZxdgNfLhYBX0jqNod9GzhjZqbNgEuT//h05u0FPnYCCytrEbwiaZs57FHgfTMzTUDZB5T9gLP6gQNOYOYMKDvBsiN01mfAPicwU0DpBZSegLPKSxRvOoGZAiYkPWUOOwi8bmamrQH3JS01h70CvGRm+gVERLmzPHAHLQ0W4AU3134bjIiVkn5zB5U0Cjzr5mYIKL27X91BS5MVeNrNzRDwjKSf3UElTQDltRtrZQgo7//9aE35L+w+sMzNzRCwVdL37qD/3LMTGqMZAsrbn2UzlFHLgb+c4AwBZRtctsMZ1QHcdoIzBJRXYEtDJKM6gZtOcIaA/ZI+dIacwnoeuO5kZwg4NoeA0WIvYggo7x7ZqmUBEVFW+7Yp4IdWwsxHQLnSR1s5acIxfcBcZt5jp64FtHo1IqKeAfVPoF4D6kXw/3sXaHXxbLfjGt4G2+2Bp1mBjR6Q5iKgPLYu2mrUQ6gFNLq0EVHPgEaS2vnz+ifQoI9YrwGNpm9EpHR4G53X9Tkw64saDwGFHzVQrUapdQAAAABJRU5ErkJggg==);
    background-size: 100% 100%;
    vertical-align: bottom;
    margin: .015625rem .052083rem .036458rem -.052083rem;
  }

  .contentnr-btn > .looking-forward:hover, .memorial-service:hover {
    background: url(data:image/png;base64,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);
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home/components/recollection.vue